module.exports = __webpack_public_path__ + "resources/img/img_cubrid_02_02_m.f77af5c5a4dc3065ae7311855cf863fb.png";